import { render } from "./discussion.html?vue&type=template&id=f363ef9e&external"
import script from "./discussion.js?vue&type=script&lang=js&external"
export * from "./discussion.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__